module.exports = __webpack_public_path__ + "img/spriggan-256.e63d44d3.png";